import { Card } from 'react-bootstrap';
import type { FulfillmentSummary } from '../../../../infrastructure/OMSClient';

interface FulfillmentSummaryCardsProps {
  summary: FulfillmentSummary;
  total: number;
}

export function FulfillmentSummaryCards({ summary, total }: FulfillmentSummaryCardsProps) {
  const calculatePercentage = (value: number) => {
    if (total === 0) {
      return 0;
    }
    return ((value / total) * 100).toFixed(1);
  };

  const stages = [
    {
      label: 'Within SLA',
      count: summary.withinSLA,
      variant: 'success',
      bgColor: '#d1e7dd',
      textColor: '#0f5132',
      borderColor: '#198754',
    },
    {
      label: 'At Risk',
      count: summary.atRisk,
      variant: 'warning',
      bgColor: '#fff3cd',
      textColor: '#664d03',
      borderColor: '#ffc107',
    },
    {
      label: 'Breached',
      count: summary.breached,
      variant: 'danger',
      bgColor: '#f8d7da',
      textColor: '#842029',
      borderColor: '#dc3545',
    },
  ];

  return (
    <div className="d-flex flex-nowrap align-items-center gap-3 p-3" style={{ overflowX: 'auto' }}>
      {stages.map((stage, index) => (
        <div key={stage.label} className="d-flex align-items-center" style={{ flexShrink: 0 }}>
          <Card
            border={stage.variant}
            style={{
              minWidth: '160px',
              backgroundColor: stage.bgColor,
              borderWidth: '3px',
              flexShrink: 0,
            }}
          >
            <Card.Body className="p-3">
              <div
                className="fw-bold mb-2"
                style={{ color: stage.textColor, fontSize: '0.9rem', whiteSpace: 'nowrap' }}
              >
                {stage.label}
              </div>
              <div className="fw-bolder mb-1" style={{ color: stage.textColor, fontSize: '2rem', lineHeight: '1' }}>
                {stage.count}
              </div>
              <div className="fw-semibold" style={{ color: stage.textColor, fontSize: '0.9rem' }}>
                {calculatePercentage(stage.count)}%
              </div>
            </Card.Body>
          </Card>
          {index < stages.length - 1 && (
            <span className="mx-2 fw-bold text-secondary" style={{ fontSize: '1.5rem', flexShrink: 0 }}>
              →
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
